import * as React from 'react'

import type { Moment } from 'moment'

import { BaseEventModel } from '@/app/models/baseEventModel'

import { useScene } from '../context/SceneContext'
import { BOTTOM_PADDING } from '../utils/layout'

export type CurrentDelegationBlockProps = {
  begin: Moment
  end: Moment
  index: number
}

const color = '#2448BB'

const prepareTooltipInfo = (
  begin: Moment,
  end: Moment,
): BaseEventModel => ({
  startTime: begin,
  endTime: end,
  typeName: 'eventName.currentDelegation',
  color,
})

export const CurrentDelegationBlock: React.FC<CurrentDelegationBlockProps> =
  React.memo((props: CurrentDelegationBlockProps) => {
    const scene = useScene()
    const HEIGHT = scene.height - 28
    const { begin, end } = props

    const width = scene.widthOf(begin, end)
    if (width <= 0) return null

    const left = scene.timeToX(begin)

    return (
      <div
        className="tw-flex tw-flex-col tw-items-start tw-justify-end"
        style={{
          position: 'absolute',
          left,
          top: 0,
          bottom: 0,
             paddingBottom: BOTTOM_PADDING,
        }}
      >
        <div
          data-tip={JSON.stringify(prepareTooltipInfo(begin, end))}
          data-for="eventTooltip"
          style={{
            background: color,
            height: HEIGHT,
            width: width,
            opacity: 0.5,
            pointerEvents: 'auto',
          }}
        />
      </div>
    )
  })

CurrentDelegationBlock.displayName = 'CurrentDelegationBlock'
